import { createSelector } from 'reselect';

const adsSelector = state => state.ads;

export default createSelector(
	[adsSelector],
	( ads ) => {
		return {
			geoLocation: ads.geoLocation,
			adSlots: ads.adSlots,
			showInterstitial: ads.showInterstitial,
			noAdsPermissions: ads.noAdsPermissions,
			secondaryAds: ads.secondaryAds,
			analytics: ads.analytics
		};
	}
);


// WEBPACK FOOTER //
// ./src/selectors/ads.js